import styled from 'styled-components';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { colors, spacing } from 'ui/theme';
import { JsonView } from 'ui/treeView';

import { EventInfo } from '../../../../domain';
import { ORDERED_TABLE_COLUMNS } from '../../constants';
import { useAlternatingRowBackgroundColor } from '../../../../components/table/useAlternatingRowBackgroundColor';

const StyledCollapsibleContent = styled(CollapsibleContent)`
  grid-column: 1 / span ${ORDERED_TABLE_COLUMNS.length};
  ${() => useAlternatingRowBackgroundColor()}
`;

const JsonViewWrapper = styled.div`
  border-radius: ${spacing.half};
  margin: ${spacing.half} ${spacing.base};
  padding: ${spacing.base};
  border: ${spacing.single} solid ${colors.grey15};
  overflow: hidden;
  background-color: ${colors.white};
`;

type CollapsibleJsonViewProps = {
  isCollapsed: boolean;
  event: EventInfo;
};

export const CollapsibleJsonView = ({ event, isCollapsed }: CollapsibleJsonViewProps) => {
  return (
    <StyledCollapsibleContent isCollapsed={isCollapsed}>
      <JsonViewWrapper>
        <JsonView
          src={event}
          storageKey={`history-${event.eventType}-${event.createdAt}`}
          tableColor={colors.purple10}
          sort
        />
      </JsonViewWrapper>
    </StyledCollapsibleContent>
  );
};
